// Relatorios.js
import React, { useState } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import * as S from "./styles";
import { gerarRelatorioCSV, gerarRelatorioPDF, buscarRelatorioPeriodo } from "../../../services/Financeiro/financeiroService";

export default function Relatorios() {
  const [tipo, setTipo] = useState("pagar");
  const [status, setStatus] = useState("todos");
  const [inicio, setInicio] = useState("");
  const [fim, setFim] = useState("");
  const [erro, setErro] = useState("");
  const [dados, setDados] = useState([
    {
      descricao: "Energia Elétrica",
      valor: 320.5,
      vencimento: "2025-04-10",
      tipo_pagamento: "Boleto",
      categoria: "Contas Fixas",
      status: "pendente"
    },
    {
      descricao: "Fornecedor Papelaria",
      valor: 159.9,
      vencimento: "2025-04-15",
      tipo_pagamento: "PIX",
      categoria: "Materiais",
      status: "pago"
    },
    {
      descricao: "Aluguel Loja",
      valor: 2100,
      vencimento: "2025-04-01",
      tipo_pagamento: "Transferência",
      categoria: "Aluguel",
      status: "vencido"
    }
  ]);

  const idRede = localStorage.getItem("id_rede");

  const handleExport = async (formato) => {
    if (!inicio || !fim) {
      setErro("Informe o período para gerar o relatório.");
      return;
    }
    try {
      const service = formato === "csv" ? gerarRelatorioCSV : gerarRelatorioPDF;
      const blob = await service(idRede, { tipo, status, inicio, fim });
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `relatorio_${tipo}_${inicio}_a_${fim}.${formato}`;
      a.click();
    } catch (error) {
      alert("Erro ao gerar relatório.");
    }
  };

  const handleExportGrafico = async () => {
    if (!inicio || !fim) {
      setErro("Informe o período para gerar o PDF com gráfico.");
      return;
    }
    try {
      const response = await fetch(`http://localhost:3040/relatorios/pdf-grafico?inicio=${inicio}&fim=${fim}`, {
        headers: { "x-id-rede": idRede },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `relatorio_grafico_${inicio}_a_${fim}.pdf`;
      a.click();
    } catch (error) {
      alert("Erro ao gerar PDF com gráfico.");
    }
  };

  const handleBuscar = async () => {
    if (!inicio || !fim) {
      setErro("Informe o período para buscar os dados.");
      return;
    }
    try {
      const resultado = await buscarRelatorioPeriodo(idRede, inicio, fim);
      setDados(resultado);
      setErro("");
    } catch (error) {
      console.error(error);
      setErro("Erro ao buscar dados do relatório.");
    }
  };

  return (
    <>
      <Header />
      <S.Container>
        <S.Title>{tipo === "pagar" ? "Contas a Pagar" : "Contas a Receber"}</S.Title>
        <S.FiltroLinha>
          <S.Select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="todos">Todos</option>
            <option value="pendente">Pendente</option>
            <option value="pago">Pago</option>
            <option value="vencido">Vencido</option>
          </S.Select>
          <S.Input type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} />
          <S.Input type="date" value={fim} onChange={(e) => setFim(e.target.value)} />
          <S.Button type="button" onClick={handleBuscar}>🔍 Pesquisar</S.Button>
        </S.FiltroLinha>

        {erro && <S.Erro>{erro}</S.Erro>}

        <S.ButtonGroup>
          <S.Button type="button" onClick={() => handleExport("pdf")}>Exportar PDF</S.Button>
          <S.Button type="button" onClick={() => handleExport("csv")}>Exportar CSV</S.Button>
          <S.Button type="button" onClick={handleExportGrafico}>PDF com Gráficos</S.Button>
        </S.ButtonGroup>

        {dados.length > 0 && (
          <S.StyledTable>
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Tipo</th>
                <th>Categoria</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dados.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.descricao}</td>
                  <td>R$ {item.valor?.toFixed(2)}</td>
                  <td>{item.vencimento?.slice(0, 10)}</td>
                  <td>{item.tipo_pagamento}</td>
                  <td>{item.categoria}</td>
                  <td>{item.status || '-'}</td>
                </tr>
              ))}
            </tbody>
          </S.StyledTable>
        )}
      </S.Container>
      <Footer />
    </>
  );
}